import { render, staticRenderFns } from "./PartnershipAdsIcon.vue?vue&type=template&id=7d188a1c&scoped=true"
import script from "./PartnershipAdsIcon.vue?vue&type=script&lang=js"
export * from "./PartnershipAdsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d188a1c",
  null
  
)

export default component.exports